import type { QueryClient } from "@tanstack/react-query";
import type { BookingV4 } from "../types/bookings";

export const selectedBookingQueryKey = (bookingId: string | undefined) =>
  ["getSelectedBooking", bookingId] as const;

export type SelectedBookingUpdater = (
  current: BookingV4 | undefined
) => BookingV4 | undefined;

/**
 * Updates the cached V4 record of a booking (the `["getSelectedBooking", id]`
 * query). Returning `undefined` from the updater leaves the cache untouched.
 */
export const updateSelectedBookingCache = (
  queryClient: QueryClient,
  bookingId: string | undefined,
  updater: SelectedBookingUpdater
): void => {
  if (!bookingId) return;
  queryClient.setQueryData<BookingV4>(
    selectedBookingQueryKey(bookingId),
    updater
  );
};
